import { render } from "./IconCaretDown.vue?vue&type=template&id=79537fcc"
const script = {}

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__